// Dynamically match .product-card-promo, its .product-card__media--promo, and its image height to the first .product-card in .collection__main
// Ensures promo card, media area, and image visually align with product grid
(function() {
  // Utility: Debounce function for resize events
  function debounce(fn, delay) {
    let timer = null;
    return function() {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }

  function setPromoCardHeight() {
    var main = document.querySelector('.collection__main');
    if (!main) return;

    // decide if we're on mobile
    var isMobile = window.innerWidth <= 699;

    var firstProductCard = main.querySelector('.product-card:not(.product-card-promo)');
    if (!firstProductCard) return;
    var height = firstProductCard.offsetHeight;
    
    var promoCards = main.querySelectorAll('.product-card-promo:not(.product-card-promo__content--pure-text)');
    promoCards.forEach(function(card) {
      // bail early on mobile, clear any inline heights
      if (isMobile) {
        card.style.height = '';
        var media = card.querySelector('.product-card__media--promo');
        if (media) {
          media.style.height = '';
          media.querySelectorAll('img').forEach(function(img) {
            img.style.height = '';
          });
        }
        return;
      }

      // existing desktop logic
      card.style.height = height + 'px';
      var media = card.querySelector('.product-card__media--promo');
      if (media) {
        media.style.height = height + 'px';
        var imgs = media.querySelectorAll('img');
        imgs.forEach(function(img) {
          img.style.height = height + 'px';
          img.style.objectFit = 'cover';
        });
      }
    });
  }

  // Run immediately on DOMContentLoaded (don't wait for images)
  document.addEventListener('DOMContentLoaded', function() {
    // Run initial height calculation
    setPromoCardHeight();
    
    // Also run again after a short delay to catch any late-loading elements
    setTimeout(setPromoCardHeight, 100);
  });

  // Also run after all images are loaded for final adjustment
  window.addEventListener('load', setPromoCardHeight);

  // Run on resize (debounced)
  window.addEventListener('resize', debounce(setPromoCardHeight, 120));

  // Optional: re-run if Shopify sections are dynamically reloaded (theme editor, etc.)
  document.addEventListener('shopify:section:load', setPromoCardHeight);
  document.addEventListener('shopify:section:select', setPromoCardHeight);
})(); 